import { useEffect } from 'react'
import { StudioTool, StudioView } from '../types'

export interface UseStudioKeyboardShortcutsOptions {
  enabled: boolean
  onSetTool: (tool: StudioTool) => void
  onSetView: (view: StudioView) => void
  onFlyToSelected: () => void
  onDeleteSelected: () => void
  onEscape: () => void
  onUndo?: () => void
  onRedo?: () => void
}

/** V/H/C tools, 1/2/3 views, F fly-to, Backspace/Delete remove, Escape deselect, ⌘Z / ⇧⌘Z — disabled while typing or the palette is open. */
export function useStudioKeyboardShortcuts(opts: UseStudioKeyboardShortcutsOptions) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (!opts.enabled) return
      const target = e.target as HTMLElement
      if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA') return

      if (e.metaKey || e.ctrlKey) {
        const key = e.key.toLowerCase()
        if (key === 'z' && !e.shiftKey) {
          e.preventDefault()
          opts.onUndo?.()
          return
        }
        if (key === 'z' && e.shiftKey) {
          e.preventDefault()
          opts.onRedo?.()
          return
        }
        if (key === 'y') {
          e.preventDefault()
          opts.onRedo?.()
          return
        }
        return
      }

      switch (e.key.toLowerCase()) {
        case 'v':
          opts.onSetTool('select')
          break
        case 'h':
          opts.onSetTool('hang')
          break
        case 'c':
          opts.onSetTool('comment')
          break
        case '1':
          opts.onSetView('orbit')
          break
        case '2':
          opts.onSetView('plan')
          break
        case '3':
          opts.onSetView('walk')
          break
        case 'f':
          opts.onFlyToSelected()
          break
        case 'backspace':
        case 'delete':
          opts.onDeleteSelected()
          break
        case 'escape':
          opts.onEscape()
          break
        default:
          break
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [opts])
}
